import LazyLoad from "vanilla-lazyload";

export function lazyLoad() {
    const lazyLoadOptions = {
        unobserve_entered: true, // <- Avoid executing the function multiple times
        callback_enter: executeLazyFunction // Assigning the function defined above
    };
    const lazyLoadInstance = new LazyLoad(lazyLoadOptions); 
    return lazyLoadInstance;
    //return 'H3llo';
}

function executeLazyFunction(element) {
    var lazyFunctionName = element.getAttribute("data-lazy-function");
    var lazyFunction = window.lazyFunctions[lazyFunctionName];
    if (!lazyFunction) return;
    lazyFunction(element);
}

// It's a best practice to scope the function names inside a namespace like `lazyFunctions`.
window.lazyFunctions = {
    inViewport: function (element) {
      element.classList.add("is-inViewport");
    },
};
